export { default } from "./GoogleClassroomIcon";
